import { env } from "@/env";
import { addressComparisonKey } from "@/utils/address";

/**
 * Set of market addresses to hide from the UI.
 * Parsed from the NEXT_PUBLIC_HIDDEN_MARKET_ADDRS env variable (JSON array of strings).
 */
export const HIDDEN_MARKET_ADDRS: ReadonlySet<string> = new Set(
  env.NEXT_PUBLIC_HIDDEN_MARKET_ADDRS.map((addr) => addressComparisonKey(addr)),
);
